import { render, staticRenderFns } from "./EventsDistributionTable.vue?vue&type=template&id=54661f22&scoped=true&"
import script from "./EventsDistributionTable.vue?vue&type=script&lang=js&"
export * from "./EventsDistributionTable.vue?vue&type=script&lang=js&"
import style1 from "./EventsDistributionTable.vue?vue&type=style&index=1&id=54661f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54661f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VDataTable})
